import { useMemo } from 'react';
import { useRouter } from 'next/router';

import { Log, useUBL } from '@common/log-manager';
import {
  convertProductItemListToUxGoodsCardItemList,
  ImageBannerListComponentType,
  useEnvConfig,
} from '@domains/storehome-common';

interface Params {
  log?: Partial<Log>;
  product_list: ImageBannerListComponentType['product_list'];
}

export const useImageCardService = ({ log, product_list }: Params) => {
  const { is_zigzag } = useEnvConfig();
  const tracker = useUBL();
  const router = useRouter();

  const product_card_list = useMemo(
    () =>
      convertProductItemListToUxGoodsCardItemList({
        item_list: product_list,
        is_zigzag,
        show_ranking: false,
      }),
    [is_zigzag, product_list],
  );

  const handleClickHeader = (event: React.MouseEvent, link_url?: string | null) => {
    event.stopPropagation();
    if (log != null) {
      tracker({
        ...log,
        navigation: 'shop_detail',
        object_type: 'button',
        category: 'click',
        object_id: 'see_more',
      });
    }
    moveToCollectionPage(link_url);
  };

  const handleClickBanner = (event: React.MouseEvent, link_url?: string | null) => {
    event.stopPropagation();
    if (log != null) {
      tracker({
        ...log,
        navigation: 'shop_detail',
        object_type: 'image',
        category: 'click',
      });
    }
    moveToCollectionPage(link_url);
  };

  const moveToCollectionPage = (link_url?: string | null) => {
    if (!link_url) {
      return;
    }

    // 일단 앱 랜딩을 통해 처리하기로 하고 아래의 코드 주석처리(https://croquis.atlassian.net/browse/SELFE-1565). by lucas
    const match = /.+url=(.+)/.exec(link_url);

    if (!match) {
      return;
    }

    const collection_detail_url = match[1];

    if (!collection_detail_url) {
      return;
    }

    if (is_zigzag) {
      return router.push(collection_detail_url);
    }

    return router.push(collection_detail_url.replace('store.', ''));
  };

  return {
    product_card_list,
    handleClickBanner,
    handleClickHeader,
  };
};
